module.exports = __webpack_public_path__ + "images/icons_v2/referral-filled-8107e1ed.svg";